module.exports = __webpack_public_path__ + "img/skpz_common.4e34e8a1.png";